export const REPORT_APPOINTMENT_STATS_REQUESTED = 'REPORT_APPOINTMENT_STATS_REQUESTED';
export const REPORT_APPOINTMENT_STATS_SUCCEED = 'REPORT_APPOINTMENT_STATS_SUCCEED';
export const REPORT_APPOINTMENT_STATS_FAILED = 'REPORT_APPOINTMENT_STATS_FAILED';

export const REPORT_APPOINTMENT_DAY_STATS_REQUESTED = 'REPORT_APPOINTMENT_DAY_STATS_REQUESTED';
export const REPORT_APPOINTMENT_DAY_STATS_SUCCEED = 'REPORT_APPOINTMENT_DAY_STATS_SUCCEED';
export const REPORT_APPOINTMENT_DAY_STATS_FAILED = 'REPORT_APPOINTMENT_DAY_STATS_FAILED';
